<div class="bg-white border border-gray-200 rounded-lg text-sm">
  <div class="p-3 flex items-center bg-gray-100">
    <div class="flex gap-2 items-center flex-auto" cdkDragHandle>
      <mat-icon>sms</mat-icon>

      <span class="font-medium">SMS notificatie</span>
    </div>

    <div class="flex">
      <ng-template
        [ngTemplateOutlet]="actions() ?? null"
        [ngTemplateOutletContext]="{ $implicit: data() }"
      />
    </div>
  </div>

  <div class="p-3 border-t border-inherit">
    <span
      class="break-words"
      [innerHTML]="data().value.message | highlightVariables"
    ></span>

    <mat-divider class="my-4! [--mat-divider-color:var(--color-gray-200)]" />

    <div>
      <div class="font-medium">Ontvangers:</div>

      <div class="flex flex-wrap gap-1 mt-1">
        @for (recipient of data().value.recipients; track $index) {
          <div
            class="bg-gray-300 text-gray-800 py-0.5 px-1 rounded-sm text-xs font-medium"
          >
            {{ recipient.name }}
          </div>
        } @empty {
          <span class="text-xs text-gray-800">Er zijn geen ontvangers</span>
        }
      </div>
    </div>
  </div>
</div>
